import React from "react";

export const extras = {
  NodeBasic:(props) => <></>, 
  NodeStart:(props) => <></>, 
  NodeIterator:(props) => <></>, 
  NodeProcess:(props) => <></>, 
  NodeBase: (props) => <></>,
  NodeSticky: (props) => <></>,
  NodeOperation: (props) => <></>,
  LoadTxt: (props) => <></>,
  EdgeEdit: (props) => <></>,
  EditProps: (props) => <></>,
  AddNode: (props) => <></>,
  NodeUI: (props) => <></>,
}
